/** tm/legal/LegalDetailPane.tsx — 선택한 글의 상세 (종류별 화면으로 나눔). 데스크톱은 3열 첫 줄 오른쪽에 도구 묶음(head)을 함께 둔다 */
import type { ReactNode } from 'react';
import LegalItemDetail from './LegalItemDetail';
import LegalNewsDetail from './LegalNewsDetail';
import LegalBillDetail from './LegalBillDetail';
import LegalNoticeDetail from './LegalNoticeDetail';
import LegalCabinetDetail from './LegalCabinetDetail';
import type { PickCompany } from './CompanyPicker';
import type { ShowToast } from './legalUi';
import type { Selection } from './legalTypes';

interface Props {
  sel: NonNullable<Selection>; mobile: boolean; companies: PickCompany[] | null; head?: ReactNode;
  onBack: () => void; onToast: ShowToast; onPatch: (p: { starred?: boolean; unread?: boolean }) => void;
  /** 「진행 단계」에서 이어진 글(입법예고·국무회의·국회 법안·법령 개정) 열기 */
  onOpen?: (s: NonNullable<Selection>) => void;
}

export default function LegalDetailPane({ sel, mobile, companies, head, onBack, onToast, onPatch, onOpen }: Props) {
  const dp = { mobile, onBack, onToast, onPatch };
  const body = sel.kind === 'news' ? <LegalNewsDetail key={`n${sel.id}`} id={sel.id} {...dp} />
    : sel.kind === 'bill' ? <LegalBillDetail key={`b${sel.id}`} id={sel.id} {...dp} onOpen={onOpen} />
      : sel.kind === 'notice' ? <LegalNoticeDetail key={`p${sel.id}`} id={sel.id} {...dp} onOpen={onOpen} />
        : sel.kind === 'cabinet' ? <LegalCabinetDetail key={`c${sel.id}`} id={sel.id} {...dp} onOpen={onOpen} />
          : <LegalItemDetail key={`l${sel.id}`} id={sel.id} companies={companies} {...dp} onOpen={onOpen} />;
  return <>
    {head && <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 6 }}>{head}</div>}
    {body}
  </>;
}
